import { Col, Row, Typography, Button, notification } from "antd";

import "./LoginAndSecuritySettingsForm.scss";
import { useBoundStore } from "store";
import { useRequestPasswordResetMutation } from "auth/queries";

export const LoginAndSecuritySettingsForm = () => {
  const user = useBoundStore((state) => state.user);
  const [api, notificationContextHolder] = notification.useNotification();
  const passwordResetMutation = useRequestPasswordResetMutation();

  const handlePasswordReset = async () => {
    try {
      await passwordResetMutation.mutateAsync();
      api.success({
        duration: 5,
        message: "Password reset email sent",
        description:
          "Check your email for a link to reset your password.",
      });
    } catch {
      api.error({
        message: "Error",
        description: "Failed to send password reset email. Please try again.",
      });
    }
  };

  return (
    <>
      {notificationContextHolder}
      <Row>
        <Col>
          <Typography.Title
            className='login-and-security-settings-title'
            level={3}
          >
            Change your password
          </Typography.Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Paragraph>
            Click the button below to receive a password reset email at your
            current email address.
          </Typography.Paragraph>
          <Typography.Paragraph>
            <strong>Current email:</strong> {user?.email}
          </Typography.Paragraph>
          <Button
            type='primary'
            size='large'
            loading={passwordResetMutation.isPending}
            onClick={handlePasswordReset}
          >
            Send Password Reset Email
          </Button>
        </Col>
      </Row>
    </>
  );
};
